import React, { Fragment, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';
import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import AuthorizationListBrowser from './AuthorizationListBrowser';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_SECURITY } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const stateRef = useRef({
    onSave: () => {}
  });

  const setStateRef = (prop, value) => {
    stateRef.current = {
      ...stateRef.current,
      [prop]: value
    };
  };

  const onRefineAuthorization = useCallback(
    authorizationId => {
      historyContext.push(`/security/authorization/${authorizationId}`);
    },
    [historyContext]
  );

  const onSaveFnChanged = useCallback((fn, disabledSave) => {
    setStateRef('onSave', fn);
    const { onDisabledSaveChange } = stateRef.current;
    onDisabledSaveChange && onDisabledSaveChange(disabledSave);
  }, []);

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_SECURITY} withForbiddenPage={false}>
          <HeaderLinks stateRef={stateRef} />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_SECURITY}>
        <AuthorizationListBrowser onRefineAuthorization={onRefineAuthorization} onSaveFnChanged={onSaveFnChanged} />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
